<template>
	<vx-card id="stopwacth" class="mb-8">
			<h4 class="subtitle mb-4 font-bold">Contagem de tempo de trabalho</h4>
			<form id="form-stopwatch" class="flex items-center">
				<div class="counter-container">
					<p class="counter">{{ timeWorked }}</p>
				</div>
				<ld-button
					id="button-counter"
					v-if="prazo.ciente &&
						!prazo.cumprido &&
						((prazo.responsavel.pk == colaborador.pk &&
						$permissions.can('timeworkedadicionar') &&
						$permissions.can('timeworkedmodificar')) || $permissions.can('autenticadosuperuser'))"
					:disabled="isLoading"
					icon-pack="feather"
					:icon="isCounting ? 'icon-pause' : 'icon-play'"
					type="filled"
					class="button-counter vs-con-loading__container"
					@click="onClick"
				>{{ isCounting ? "Pausar" : "Iniciar" }}</ld-button>
			</form>
		</vx-card>
</template>

<script>
import DateHelper from '../../../../../../helpers/DateHelper';
import moment from 'moment';
import Prazo from '../../../../../../models/Prazo';
import configs from '../../../../../../config';
import ErrorHelper from '../../../../../../helpers/ErrorHelper';
import Colaborador from '../../../../../../models/Colaborador';

export default {
	name: "Stopwatch",
	data() {
		return {
			timeWorkedInterval: null,
			isLoading: false,
			currentDuration: null,
		};
	},
	props: {
		prazo: {
			required: true,
		},
		onStarted: {
			type: Function,
		},
		onPaused: {
			type: Function,
		},
	},
	computed: {
		colaborador() {
			console.log(Colaborador.getColaborador());
			return Colaborador.getColaborador() || {};
		},
		counter() {
			if (this.prazo && this.prazo.contagem_tempo_trabalhado) {
				return this.prazo.contagem_tempo_trabalhado;
			}

			return 0;
		},
		isCounting() {
			if (this.prazo && this.prazo.ultimo_tempo_trabalhado) {
				return !!this.prazo.ultimo_tempo_trabalhado.contando || false;
			}

			return false;
		},
		startCountingData() {
			if (this.prazo && this.prazo.ultimo_tempo_trabalhado) {
				return DateHelper.toDate(this.prazo.ultimo_tempo_trabalhado.started_at);
			}

			return null
		},
		timeWorked() {
			if (!this.currentDuration) {
				return "00h:00m:00s";
			}

			return this.currentDuration.format("hh[h]:mm[m]:ss[s]", {trim: false})
		}
	},
	methods: {
		getDuration() {
			const counterDuration = moment.duration({milliseconds: this.counter});

			if (this.isCounting && this.startCountingData) {
				let startCountDate = moment(this.startCountingData);
				let now = moment();

				if (now >= startCountDate) {
					counterDuration.add(now.diff(startCountDate, 'ms', true), 'ms')
				}
			}

			return counterDuration;
		},
		startCount() {
			if (this.timeWorkedInterval) {
				clearInterval(this.timeWorkedInterval);
			}

			if (this.isCounting && this.prazo.ciente && !this.prazo.cumprido) {
				this.currentDuration = this.getDuration();
				this.timeWorkedInterval = setInterval(() => {
					this.currentDuration = this.getDuration();
				}, 1000);
			}

		},
		async iniciarContagem() {
			try {
				ErrorHelper.cleanFormErrors(null, "#form-stopwatch");
				this.isLoading = true;
				this.$vs.loading({
					...configs.loadingConfigs,
					container: "#button-counter",
					scale: 0.60
				});

				const timeworked = await Prazo.iniciarContagemTempoTrabalhado(
					this.prazo.empresa,
					this.prazo.pk,
				);

				const { prazo } = timeworked;
				this.prazo.contagem_tempo_trabalhado = prazo.contagem_tempo_trabalhado
				this.prazo.ciente = prazo.ciente;
				this.prazo.cumprido = prazo.cumprido;
				this.prazo.responsavel.pk = prazo.responsavel;

				this.prazo.ultimo_tempo_trabalhado = timeworked;

				if (this.onStarted) {
					this.onStarted();
				}

				this.startCount();
			} catch (error) {
				console.error(error);
				ErrorHelper.renderFormError("#form-stopwatch", error);
			} finally {
				setTimeout(() => {
					this.isLoading = false;
					this.$vs.loading.close("#button-counter > .con-vs-loading");
				}, 500);
			}
		},
		async pausarContagem() {
			try {
				if (this.timeWorkedInterval) {
					clearInterval(this.timeWorkedInterval);
				}

				ErrorHelper.cleanFormErrors(null, "#form-stopwatch");
				this.isLoading = true;
				this.$vs.loading({
					...configs.loadingConfigs,
					container: "#button-counter",
					scale: 0.60
				});

				const timeworked = await Prazo.pausarContagemTempoTrabalhado(
					this.prazo.empresa,
					this.prazo.pk,
					this.prazo.ultimo_tempo_trabalhado.pk,
				);

				const { prazo } = timeworked;
				this.prazo.contagem_tempo_trabalhado = prazo.contagem_tempo_trabalhado
				this.prazo.ciente = prazo.ciente;
				this.prazo.cumprido = prazo.cumprido;
				this.prazo.responsavel.pk = prazo.responsavel;

				this.prazo.ultimo_tempo_trabalhado = timeworked;
				this.currentDuration = this.getDuration();

				if (this.onPaused) {
					this.onPaused();
				}
			} catch (error) {
				console.error(error);
				ErrorHelper.renderFormError("#form-stopwatch", error);
			} finally {
				setTimeout(() => {
					this.isLoading = false;
					this.$vs.loading.close("#button-counter > .con-vs-loading");
				}, 500);
			}
		},
		async onClick() {
			if (this.isCounting) {
				this.pausarContagem();
			} else {
				this.iniciarContagem();
			}
		}
	},
	watch: {
		prazo() {
			this.startCount();
		}
	},
	beforeMount() {
		this.currentDuration = this.getDuration();
		this.startCount()
	},
	beforeDestroy() {
		if (this.timeWorkedInterval) {
			clearInterval(this.timeWorkedInterval);
		}
	}
}
</script>



<style lang="scss" src="./stopwatch.scss"></style>
